const date  = new Date();
const year = date.getFullYear();
const month = year+'-'+( '0'+(date.getMonth()+1)).slice(-2);

const ModelAides = {
  cmu_c: {
    // loi 1er novembre 2019  cmu_c  --> ASS
    type: 'boolean',
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_assurance_maladie.png',
    link: 'https://www.aide-sociale.fr/complementaire-sante-solidaire/',
    label: 'Complémentaire santé solidaire'
  },

  css_participation_forfaitaire: {
    type: 'number', // type complex css
    definition_period: month,
    entity: 'famille',
    imgSrc: 'logo_assurance_maladie.png',
    link: 'https://www.aide-sociale.fr/complementaire-sante-solidaire/',
    label: 'Complémentaire santé solidaire'
  }
};


const setupCalculsDroits = ()=>{
	const droits = Object.keys(ModelAides);
	var data = {};
	droits.forEach( (droit)=> {
		data[droit.entity] = null;
	})
	return ;
}

const getDroitsAvailable = (entities , definedRessources= [])=>{
	const droits = Object.keys(ModelAides);
	var droitsBeneficiable = [];
	droits.forEach((droit)=>{
		const model = ModelAides[droit];
		var data;
		if ( model.entity === 'famille'  && ![undefined,null].includes(entities.familles)) {
			data = entities.familles._[droit];
		}
		else if ( model.entity === 'foyer_fiscal' && ![undefined,null].includes(entities.foyers_fiscaux)) {
			data = entities.foyers_fiscaux._[droit];
		}
		else if ( model.entity === 'individu' && ![undefined,null].includes(entities.individus)) {
			data = entities.individus.individu[droit];
		}
		else if ( model.entity === 'menage' && ![undefined,null].includes(entities.menages)) {
			data = entities.menages._[droit];
		}
		if (data !== undefined) {
			var value = data[model.definition_period] ;
      
      if ( droit === "aide_logement" && value  > 100){
        //value = Math.round( 0.996047*value+16.6008);
      }
			
      if (  value > 0 && !(
          (model.floorAt !== undefined && value < model.floorAt) )
           
        ) {
        model.nom = droit;
        var addDroit = true;
        
        var nonChequeEnergie = entities.individus.individu.enfant_a_charge == true;

        if (droit === 'cheque_energie' && nonChequeEnergie ) {
          addDroit = false;
        }
        

        if ( !definedRessources.includes(model.nom) && addDroit){
				  droitsBeneficiable.push ( { ...model , ...{'value':value} });
        }
			}
		}

	});

	return droitsBeneficiable;
}

const traitementAidesCategories = (aides)=> {
	var droitsBeneficiable = {};
  for ( let categorie in aides) {
    droitsBeneficiable[categorie] = aides[categorie].map((droit)=>(
      {
        label: droit.nom,
        type: typeof droit.montant,
        value: droit.montant,
        imgSrc: droit.image,
        link: droit.link,
        indication : droit.indication,
      }
    ));
  }

	return droitsBeneficiable;
}

export {ModelAides , getDroitsAvailable , traitementAidesCategories, setupCalculsDroits};